import { LANGUAGE_KEYS } from 'config/languageKeys';

import {
    Audio,
    PlayerTrackEncodeType,
    PlayerTracks,
    Subtitle,
} from './reducer.types';

const { SCREEN_SUBTITLE_OFF, SETTINGS_HUNGARIAN, SETTINGS_ENGLISH } =
    LANGUAGE_KEYS;

export const OFF_OPTION: PlayerTracks['textTracks'][number] = {
    encodeType: PlayerTrackEncodeType.UNKNOWN,
    title: SCREEN_SUBTITLE_OFF,
    language: '',
    id: undefined,
};

export const AUDIO_SUBTITLES_OFF = 'n/a';
export const AUDIO_SUBTITLES_HUNGARIAN = 'hu';
export const AUDIO_SUBTITLES_ENGLISH = 'en';
const AUDIO_SUBTITLES_CZECH = 'cs';
const AUDIO_SUBTITLES_ROMANIAN = 'ro';
const AUDIO_SUBTITLES_GERMAN = 'de';
const AUDIO_SUBTITLES_FRENCH = 'fr';
const AUDIO_SUBTITLES_DUTCH = 'nl';
const AUDIO_SUBTITLES_UKRAINIAN = 'uk';
const AUDIO_SUBTITLES_ITALIAN = 'it';
const AUDIO_SUBTITLES_SPANISH = 'es';
const AUDIO_SUBTITLES_RUSSIAN = 'ru';
const AUDIO_SUBTITLES_POLISH = 'pl';
const AUDIO_SUBTITLES_CHINESE = 'zh';
const AUDIO_SUBTITLES_CROATIAN = 'hr';
const AUDIO_SUBTITLES_SERBIAN = 'sr';
const AUDIO_SUBTITLES_SLOVAK = 'sk';
const AUDIO_SUBTITLES_SLOVENIAN = 'sl';

export const SELECTED_OPTION_TO_TRANSLATION: Record<Subtitle | Audio, string> =
    {
        [AUDIO_SUBTITLES_OFF]: SCREEN_SUBTITLE_OFF,
        [AUDIO_SUBTITLES_HUNGARIAN]: SETTINGS_HUNGARIAN,
        [AUDIO_SUBTITLES_ENGLISH]: SETTINGS_ENGLISH,
    };

export const PLAYER_TRACK_LANGUAGE_TO_LANGUAGE_OPTIONS = {
    [AUDIO_SUBTITLES_HUNGARIAN]: ['hu', 'hun'],
    [AUDIO_SUBTITLES_ENGLISH]: ['en', 'eng'],
    [AUDIO_SUBTITLES_CZECH]: ['cs', 'csz'],
    [AUDIO_SUBTITLES_ROMANIAN]: ['ro', 'rum'],
    [AUDIO_SUBTITLES_GERMAN]: ['de', 'ger', 'deu'],
    [AUDIO_SUBTITLES_FRENCH]: ['fr', 'fra'],
    [AUDIO_SUBTITLES_DUTCH]: ['nl', 'dut'],
    [AUDIO_SUBTITLES_UKRAINIAN]: ['uk', 'ukr'],
    [AUDIO_SUBTITLES_ITALIAN]: ['it', 'ita'],
    [AUDIO_SUBTITLES_SPANISH]: ['es', 'spa'],
    [AUDIO_SUBTITLES_RUSSIAN]: ['ru', 'rus'],
    [AUDIO_SUBTITLES_POLISH]: ['pl', 'pol'],
    [AUDIO_SUBTITLES_CHINESE]: ['zh', 'chi'],
    [AUDIO_SUBTITLES_CROATIAN]: ['hr', 'hrv'],
    [AUDIO_SUBTITLES_SERBIAN]: ['sr', 'srp'],
    [AUDIO_SUBTITLES_SLOVAK]: ['sk', 'slk', 'slo'],
    [AUDIO_SUBTITLES_SLOVENIAN]: ['sl', 'slv'],
};
